// src/store/slices/layoutSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LayoutState {
  isBottomNavVisible: boolean;
  isSideMenuOpen: boolean;
}

const initialState: LayoutState = {
  isBottomNavVisible: true,
  isSideMenuOpen: false,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setBottomNavVisible: (state, action: PayloadAction<boolean>) => {
      state.isBottomNavVisible = action.payload;
    },
    toggleBottomNav: (state) => {
      state.isBottomNavVisible = !state.isBottomNavVisible;
    },
    setSideMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isSideMenuOpen = action.payload;
    },
    toggleSideMenu: (state) => {
      state.isSideMenuOpen = !state.isSideMenuOpen;
    },
  },
});

export const {
  setBottomNavVisible,
  toggleBottomNav,
  setSideMenuOpen,
  toggleSideMenu,
} = layoutSlice.actions;

export default layoutSlice.reducer;
